export const isCreatingRunRecords = state => state.runRecords.creatingRunRecords;
export const isLoadingRecords = state => state.runRecords.loadingRecords;
export const getMeta = state => state.runRecords.meta;
export const getEditRow = state => state.runRecords.editRow;
export const getEditingRecord = state => state.runRecords.editingRecord;
export const getAllRecordsSelected = state => state.runRecords.meta.allRecordsSelected;
export const getTotalErrors = state => state.runRecords.meta.totalErrors;
export const getRecordIds = state => state.runRecords.recordIds;
export const getRecords = state => state.runRecords.records;
export const getHeaders = state => state.runRecords.headers;
export const getRecordPage = state => state.runRecords.recordPage;
export const getImportSummary = state => state.runRecords.importSummary;
